import { render, staticRenderFns } from "./ScreenView.vue?vue&type=template&id=e852a3f0&scoped=true"
import script from "./ScreenView.vue?vue&type=script&lang=js"
export * from "./ScreenView.vue?vue&type=script&lang=js"
import style0 from "./ScreenView.vue?vue&type=style&index=0&id=e852a3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e852a3f0",
  null
  
)

export default component.exports